import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store/index";

Vue.config.productionTip = false;

// vue2 element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import zhLang from "element-ui/lib/locale/lang/zh-CN"; // 引入官方的中文國際化
import localeTW from "./assets/locale/tw"; // 引入自己的
Vue.use(ElementUI, {
  locale: { ...zhLang, ...localeTW }, // 使用本地的 locale 去覆蓋官方的 zhLang
});

// Axios
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

// bootstrap vue
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// common.js
import common from "@/common.js";

// 驗證token(解決弱點掃描問題)
function chkReg(t) {
  const reg = /[a-zA-Z]+/;
  if (reg.test(t)) {
    return t;
  } else {
    return false;
  }
}

// 添加請求攔截器 發送資料
axios.interceptors.request.use(
  (config) => {
    // way 1
    // 在發送請求之前做些什麼
    //判斷是否存在token，如果存在將每個頁面header都添加token
    if (chkReg(localStorage.getItem("ah"))) {
      let token = localStorage.getItem("ah");
      let ac = localStorage.getItem("ac") ?? "X";
      let af = localStorage.getItem("af") ?? "X";
      let an = localStorage.getItem("an") ?? "X";
      // const token = store.state.access_token;
      if (token) {
        config.headers = {
          Authorization: `Bearer ${token ?? ""}`,
          af: af,
          ac: ac,
          an: an,
        };
        // config.headers["Authorization"] = `Bearer ${
        //   token !== undefined ? token : ""
        // } `;
      }
    }
    vm.$root.overlay = true;
    return config;
  },
  (error) => {
    console.log("axios request catch err: ", error);
    // 對請求錯誤做些什麼
    return Promise.reject(error);
  }
);

// http response 攔截器 取回資料
axios.interceptors.response.use(
  (res) => {
    // apim 接的格式
    if (res.data.data && res.data.data.access_token) {
      if (chkReg(res.data.data.access_token)) {
        let t4use = res.data.data.access_token;
        localStorage.setItem("ah", chkReg(t4use));
      }
    } else {
      if (chkReg(res.headers.ah)) {
        let t4use = res.headers.ah;
        localStorage.setItem("ah", chkReg(t4use));
        // 2024.03.22 判斷是否為blob格式，若是，則不更新線上人數及姓名
        if (
          !(
            res.config &&
            res.config.responseType &&
            res.config.responseType === "blob"
          )
        ) {
          store.state.onlineTotal = res.data.onlineTotal;
          store.state.loginName = res.data.loginName;
        }
      }
      localStorage.setItem("ac", res?.headers?.ac ?? "X");
      localStorage.setItem("af", res?.headers?.af ?? "X");
      localStorage.setItem("an", res?.headers?.an ?? "X");
    }
    vm.overlay = false;
    // console.log(res);
    return res;
  },
  (err) => {
    // console.log("axios response catch err: ", err);
    let ah = err.response.headers.ah || null;
    if (err && ah) {
      if (chkReg(ah)) {
        let t4use = ah;
        localStorage.setItem("ah", chkReg(t4use));
      }
    }

    vm.overlay = false;
    // 碰到api 的錯誤訊息格式

    switch (err.response.status) {
      case 401:
        vm.$message({
          type: "error",
          duration: 5000,
          showClose: true,
          message: `系統錯誤，已導回登入頁面`,
        });
        router.replace({ name: "index" });
        break;
      case 400:
      case 500:
        vm.$message({
          type: "error",
          duration: 5000,
          showClose: true,
          message: `失敗: ${
            err.response.data.message
              ? err.response.data.message
              : err.response.data
              ? err.response.data.errMsg
              : err.message
          }`,
        });
        break;
      case 999:
        vm.$message({
          type: "error",
          duration: 5000,
          showClose: true,
          message: "系統維護中",
        });
        vm.$store.commit("MAINTAIN_HADNDLER", err.response.data.data);
        router.replace({ name: "999" });
        break;
      default:
        vm.$message({
          type: "error",
          duration: 5000,
          showClose: true,
          message: `失敗: 系統發生錯誤`,
        });
        break;
    }
    return Promise.reject(err);
  }
);

Vue.mixin(common);

var vm = new Vue({
  router,
  store,
  data() {
    return {
      // 畫面共用loading 功能
      overlay: true,
    };
  },
  render: (h) => h(App),
}).$mount("#app");
